import React from 'react';
import styled from '@emotion/styled';
import { Media } from '../Media/Media';
import getCardDetails from '../../util/getCardDetails';
import { EmotionBreakpoint } from 'dw-us-ui';

const InfoBlockContentContainer = styled.div`
  ${EmotionBreakpoint('notDesktop')} {
    .infoBlockMediaContainer {
      .embed-responsive-item {
        height: 250px;
      }
    }
  }
  .info-block-title {
    font-size: 1rem;
    text-align: left;
    padding: 0px 0 10px 0;
    color: #000;
    font-weight: 700;
  }
  .info-block-text {
    text-align: left;
    margin-bottom: 10px;
    ul {
      list-style: unset;
      padding-inline-start: 22px;
    }
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .infoBlockMediaContainer {
    margin-bottom: 10px;
    .embed-responsive-item {
      height: 165px;
    }
  }
`;

const InfoBlock = ({ fields }) => {
  let cardDetails = getCardDetails(fields?.blocks);

  return (
    <InfoBlockContentContainer>
      <div className="infoBlockMediaContainer">
        <div>
          {/* {fields?.youtubeMedia?.fields?.videoId ? (   temp
						<YoutubePlayer videoId={fields?.youtubeMedia?.fields?.videoId} />
					) : ( */}
          <Media src={cardDetails?.backgroundImage} srcMob={cardDetails?.mobileBackgroundImage} alt={'imageAlt'} />
        </div>
      </div>
      <div data-testid="info-block-title">
        {fields?.youtubeMedia?.fields?.videoId ? null : (
          <div className="pl-0 pb-2">
            <p className="info-block-title">{cardDetails?.title}</p>
          </div>
        )}
      </div>
      {cardDetails?.content && (
        <div data-testid="info-block-text">
          <div className="pl-0 info-block-text">{cardDetails?.content}</div>
        </div>
      )}
    </InfoBlockContentContainer>
  );
};

export { InfoBlock };
